import { combineReducers } from 'redux';

const contentPending = (state, action) => action.type && action.type.includes('PENDING');

export default combineReducers(
  {
    contentPending
  }
);
